import { ApiError } from "@porchpass/api-client";

export function assertApiSuccess<T>(
  response: { status: number; data: unknown },
  expectedStatus = 200,
): T {
  if (response.status !== expectedStatus) {
    const message =
      typeof response.data === "object" &&
      response.data !== null &&
      "message" in response.data &&
      typeof (response.data as { message?: string }).message === "string"
        ? (response.data as { message: string }).message
        : "Request failed";
    throw new ApiError(response.status, message, response.data);
  }
  return response.data as T;
}

export function assertApiSuccessNoContent(response: { status: number }): void {
  if (response.status !== 204 && response.status !== 200) {
    throw new ApiError(response.status, "Request failed");
  }
}
